import { defineComponent as _defineComponent } from 'vue'
import {
        computed, unref,
    } from 'vue';
    import { debounce } from 'underscore';
    import InputCommon from '@ve/components/inputs/InputCommon.vue';
    import { formatNumber } from '@shared/lib';
    import useBudgetFilterModel from '../lib/useBudgetFilterModel';
    import maskPriceInput from '../config/maskPriceInput';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceInputs',
  props: {
    maxPrice: null,
    minPrice: null
  },
  setup(__props: any) {

const props = __props as {
        maxPrice: number;
        minPrice: number;
    }

    

    const {
        setMaxPrice,
        setMinPrice,
        maxPriceFilter,
        minPriceFilter,
    } = useBudgetFilterModel();

    const maxPricePlaceholder = computed(() => formatNumber(props.maxPrice));
    const minPricePlaceholder = computed(() => formatNumber(props.minPrice));

    const deleteSpace = (str: string): string => str.replace(/\s+/g, '');

    const INPUT_DEBOUNCE = 600;

    const maxPriceFilterInput = computed({
        get: () => (maxPriceFilter.value ? formatNumber(maxPriceFilter.value) : ''),
        set: debounce<(valueWithSpace: string) => void>((valueWithSpace) => {
            const maxPrice = Number(deleteSpace(valueWithSpace));
            setMaxPrice(maxPrice || null);
        }, INPUT_DEBOUNCE),
    });

    const minPriceFilterInput = computed({
        get: () => (minPriceFilter.value ? formatNumber(minPriceFilter.value) : ''),
        set: debounce<(valueWithSpace: string) => void>((valueWithSpace) => {
            const minPrice = Number(deleteSpace(valueWithSpace));
            setMinPrice(minPrice || null);
        }, INPUT_DEBOUNCE),
    });


return { __sfc: true,props, setMaxPrice, setMinPrice, maxPriceFilter, minPriceFilter, maxPricePlaceholder, minPricePlaceholder, deleteSpace, INPUT_DEBOUNCE, maxPriceFilterInput, minPriceFilterInput, InputCommon, maskPriceInput }
}

})